import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { setCheckLists, setDisport, setDisportAgent, setDisportAgentType, setIsSendDraftToFN, setLoadport, setLoadportAgent, setLoadportAgentType, setOffhireBunkerPort, setOffhireBunkerSurveyorCompany, setOffhireBunkerSurveyorDetailAndCost, setOnhireBunkerPort, setOnhireBunkerSurveyorCompany, setOnhireBunkerSurveyorDetailAndCost, SupportSheetSelector } from './reducers/SupportSheetReducer';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { Autocomplete, AutocompleteChangeDetails, Grid, Switch, TextField } from '@mui/material';
import { portSelectorSelector } from '../PortSelector/reducers/PortSelectorReducer';
import { CheckList, CheckListHistoryItem, SupportSheetStatus } from './models/SupportSheetModel';
import { SupportSheetCheckListConstant } from './models/SupportSheetCheckListConstant';
import { SupportSheetHelpTextConstant } from './models/SupportSheetHelperTextConstant';
import { MarketInfoType } from '../MarketInfo/models/MarketInfoQueryModel';
import SupportSheetCustomCheckbox from './components/SupportSheetCustomCheckbox/SupportSheetCustomCheckbox';
import EmailEditorModel from '../EmailEditorModal/models/EmailEditorModel';
import Utility from '../../app/utility';
import { SupportSheetEmailContentConstant } from './models/SupportSheetEmailContentConstant';
import AgentSelector from '../AgentSelector/AgentSelector';
import PortSelector from '../PortSelector/PortSelector';
import PortModel from '../PortSelector/models/PortModel';
import SurveyorSelector from '../SurveyorSelector/SurveyorSelector';
import { contructEmailSubjectPrefix, getErrorClass, getErrorNumberClass, hasError, hasErrorNumber } from './SupportSheetBiefInformation';
import AgentModel from '../Agent/models/AgentModel';
import SupportSheetHelpText from './components/SupportSheetHelpText/SupportSheetHelpText';
import SurveyorModel from '../Surveyor/models/SurveyorModel';

export const PopupEmail = (model: EmailEditorModel, brokerEmails: string) => {
    let body = "Dear " + model.receivedName + ",\n\n" + model.emailContent + "\n";
    body = body.replaceAll("\n", "%0D%0A");
    body = body.replaceAll("\n", "&nbsp;&nbsp;&nbsp;");

    let mailTo = "mailto:" + model.emailTo +
        "?subject=" + model.emailSubject +
        "&body=" + body;

    if (model.emailCc && model.emailCc.length > 0) {
        mailTo = mailTo + "&cc=" + model.emailCc;
    }

    window.location.href = mailTo;
}

const SupportSheetPreVoyage: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);
    const portSelectorData = useSelector(portSelectorSelector);

    const getPortById = (portId: number | null) => {
        if (portId == null) {
            return null;
        }
        let selectedPort = _.find(portSelectorData.ports, (port) => {
            return port.id === portId;
        });

        if (selectedPort) {
            return selectedPort;
        }

        return null;
    }


    const updateCheckList = (checkListName: string, isAdded: boolean) => {
        let checkList = supportSheetData.model.checkLists ? JSON.parse(supportSheetData.model.checkLists) as CheckList :
            {
                checkListItems: [],
                history: []
            } as CheckList;

        if (isAdded) {
            checkList.checkListItems.push(checkListName);

            //history
            let index = _.findIndex(checkList.history, (item) => {
                return item.name === checkListName;
            });

            if (index === -1) {
                checkList.history.push({
                    name: checkListName.replace(".", ""),
                    date: new Date().toISOString()
                } as CheckListHistoryItem)
            }
        } else {
            let removeIndex = _.indexOf(checkList.checkListItems, checkListName);
            checkList.checkListItems.splice(removeIndex, 1);
        }

        dispatch(setCheckLists(JSON.stringify(checkList)));
    }

    const isDontFollowShipment = () => {
        return supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['We dont follow this shipment']) > -1 : false;
    }

    return (
        <>
            <CustomAccordion
                title="Pre-Voyage"
                defaultOpen={true}
                open={supportSheetData.model.status == SupportSheetStatus.PreArrivalLoadPort ||
                    supportSheetData.model.status == SupportSheetStatus.OnVoyage ||
                    supportSheetData.model.status == SupportSheetStatus.PreDelivery ||
                    supportSheetData.model.status == SupportSheetStatus.Delivered ||
                    supportSheetData.model.status == SupportSheetStatus.Cancel}
                onOpenChange={(isOpen: boolean) => {
                }}
            >
                <Grid container>
                    <Grid item xs={4}>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Check Hanover']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Check Hanover'], checked);
                            }}
                            currentCheckedValue={SupportSheetCheckListConstant['Check Hanover']}
                            helpText={SupportSheetHelpTextConstant['Check handover carefully']}
                            checkboxText={'Check handover carefully'}
                            showSendEmail={false}
                        ></SupportSheetCustomCheckbox>
                    </Grid>
                    <Grid item xs={8}>
                        <div>
                            <Switch
                                className='support-sheet-switch'
                                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                    updateCheckList(SupportSheetCheckListConstant['We dont follow this shipment'], checked);
                                }}
                                checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['We dont follow this shipment']) > -1 : false} />
                            <span
                                onClick={() => {
                                    if (supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['We dont follow this shipment']) > -1 : false) {
                                        updateCheckList(SupportSheetCheckListConstant['We dont follow this shipment'], true);
                                    } else {
                                        updateCheckList(SupportSheetCheckListConstant['We dont follow this shipment'], false);
                                    }
                                }}
                                className='checkbox-text'
                            >
                                We don't follow this shipment
                            </span>
                        </div>
                    </Grid>
                </Grid>
                <SupportSheetCustomCheckbox
                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Send greating to owners']) > -1 : false}
                    onChange={(checked: boolean) => {
                        updateCheckList(SupportSheetCheckListConstant['Send greating to owners'], checked);
                    }}
                    disable={isDontFollowShipment()}
                    currentCheckedValue={SupportSheetCheckListConstant['Send greating to owners']}
                    helpText={SupportSheetHelpTextConstant['Send support greating to owners']}
                    checkboxText={' Send Support Greeting to Owners'}
                    showSendEmail={true}
                    onEmailClick={() => {
                        if (supportSheetData.ownerBrokerContactPrinciple) {
                            PopupEmail({
                                emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                emailSubject: contructEmailSubjectPrefix(supportSheetData) + "SUPPORT GREETINGS",
                                emailContent: SupportSheetEmailContentConstant["Send support greating"],
                                receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                            } as EmailEditorModel, supportSheetData.brokerEmails);
                        } else {
                            Utility.Alert.Error("Please select owner principle before sending email");
                        }
                    }}
                ></SupportSheetCustomCheckbox>
                <SupportSheetCustomCheckbox
                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Send greating to chtrs']) > -1 : false}
                    onChange={(checked: boolean) => {
                        updateCheckList(SupportSheetCheckListConstant['Send greating to chtrs'], checked);
                    }}
                    disable={isDontFollowShipment()}
                    currentCheckedValue={SupportSheetCheckListConstant['Send greating to chtrs']}
                    helpText={SupportSheetHelpTextConstant['Send support greating to chtrs']}
                    checkboxText={'Send Support Greeting to Charterers'}
                    showSendEmail={true}
                    onEmailClick={() => {
                        if (supportSheetData.chartererBrokerContactPrinciple) {
                            PopupEmail({
                                emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                emailSubject: contructEmailSubjectPrefix(supportSheetData) + "SUPPORT GREETINGS",
                                emailContent: SupportSheetEmailContentConstant["Send support greating"],
                                receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                            } as EmailEditorModel, supportSheetData.brokerEmails);
                        } else {
                            Utility.Alert.Error("Please select owner principle before sending email");
                        }
                    }}
                ></SupportSheetCustomCheckbox>
                <SupportSheetCustomCheckbox
                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Create folder on onedrive']) > -1 : false}
                    onChange={(checked: boolean) => {
                        updateCheckList(SupportSheetCheckListConstant['Create folder on onedrive'], checked);
                    }}
                    currentCheckedValue={SupportSheetCheckListConstant['Create folder on onedrive']}
                    helpText={SupportSheetHelpTextConstant['Create folder on OneDrive']}
                    checkboxText={'Create folder on Onedrive?'}
                    showSendEmail={false}
                ></SupportSheetCustomCheckbox>

                {
                    (supportSheetData.currentFixture.bizType == MarketInfoType.Voy || supportSheetData.currentFixture.bizType == MarketInfoType.COA) &&
                    <>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Loi format']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Loi format'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Loi format']}
                            helpText={SupportSheetHelpTextConstant['LOI format']}
                            checkboxText={'LOI format'}
                            showSendEmail={true}
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "LOI format",
                                        emailContent: SupportSheetEmailContentConstant["LOI format"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                        <Grid container>
                            <Grid item xs={4}>
                                <SupportSheetCustomCheckbox
                                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Agent details at loadport']) > -1 : false}
                                    onChange={(checked: boolean) => {
                                        updateCheckList(SupportSheetCheckListConstant['Agent details at loadport'], checked);
                                    }}
                                    disable={isDontFollowShipment()}
                                    currentCheckedValue={SupportSheetCheckListConstant['Agent details at loadport']}
                                    helpText={SupportSheetHelpTextConstant['Agent details at loadport']}
                                    checkboxText={'Agent details at loadport'}
                                    showSendEmail={true}
                                    onEmailClick={() => {
                                        if (supportSheetData.model.loadportAgentType === "Owner") {
                                            if (supportSheetData.ownerBrokerContactPrinciple) {
                                                PopupEmail({
                                                    emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                                    emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                                    emailSubject: contructEmailSubjectPrefix(supportSheetData) + "AGENT DETAILS AT LOADPORT",
                                                    emailContent: SupportSheetEmailContentConstant["Agent details at loadport Owners"],
                                                    receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                                } as EmailEditorModel, supportSheetData.brokerEmails);
                                            } else {
                                                Utility.Alert.Error("Please select owner principle before sending email");
                                            }
                                        } else {
                                            if (supportSheetData.chartererBrokerContactPrinciple) {
                                                PopupEmail({
                                                    emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                                    emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                                    emailSubject: contructEmailSubjectPrefix(supportSheetData) + "AGENT DETAILS AT LOADPORT",
                                                    emailContent: SupportSheetEmailContentConstant["Agent details at loadport Chtrs"],
                                                    receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                                } as EmailEditorModel, supportSheetData.brokerEmails);
                                            } else {
                                                Utility.Alert.Error("Please select owner principle before sending email");
                                            }
                                        }
                                    }}
                                ></SupportSheetCustomCheckbox>
                            </Grid>
                            <Grid item xs={8}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Autocomplete
                                            disableClearable={true}
                                            options={["Owners", "Chtrs"]}
                                            disabled={isDontFollowShipment()}
                                            renderInput={(params) =>
                                                <TextField {...params} label="Agent Type"
                                                    error={
                                                        hasError(supportSheetData.enableValidation, supportSheetData.model.loadportAgentType, isDontFollowShipment())
                                                    } />}
                                            value={supportSheetData.model.loadportAgentType}
                                            onChange={(event: React.SyntheticEvent, value: string, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                                dispatch(setLoadportAgentType(value));
                                            }}
                                            className={'support-sheet-send-draft-dropdown' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.loadportAgentType, isDontFollowShipment())}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <PortSelector
                                            onPortChange={(value: PortModel | null) => {
                                                if (value) {
                                                    dispatch(setLoadport((value as PortModel).id));
                                                } else {
                                                    dispatch(setLoadport(null));
                                                }
                                            }}
                                            disable={isDontFollowShipment()}
                                            portLabel='Port Name'
                                            isAreaDisabled={true}
                                            hideArea={true}
                                            portValue={getPortById(supportSheetData.model.loadport)}
                                            isAreaRelatedToPort={true}
                                            hasPortError={hasErrorNumber(supportSheetData.enableValidation, supportSheetData.model.loadport, isDontFollowShipment())}
                                            className={'cargo-input-component' + getErrorNumberClass(supportSheetData.enableValidation, supportSheetData.model.loadport, isDontFollowShipment())}
                                        >
                                        </PortSelector>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <AgentSelector
                                            label='Company Name'
                                            disabled={isDontFollowShipment()}
                                            selectedAgentId={supportSheetData.model.loadportAgent}
                                            onChange={(value: AgentModel | null) => {
                                                dispatch(setLoadportAgent(value ? value.id : null));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.loadportAgent, isDontFollowShipment())
                                            }
                                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.loadportAgent, isDontFollowShipment())}
                                        >
                                        </AgentSelector>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <SupportSheetCustomCheckbox
                                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Agent details at disport']) > -1 : false}
                                    onChange={(checked: boolean) => {
                                        updateCheckList(SupportSheetCheckListConstant['Agent details at disport'], checked);
                                    }}
                                    disable={isDontFollowShipment()}
                                    currentCheckedValue={SupportSheetCheckListConstant['Agent details at disport']}
                                    helpText={SupportSheetHelpTextConstant['Agent details at disport']}
                                    checkboxText={'Agent details at disport'}
                                    showSendEmail={true}
                                    onEmailClick={() => {
                                        if (supportSheetData.model.disportAgentType === "Owner") {
                                            if (supportSheetData.ownerBrokerContactPrinciple) {
                                                PopupEmail({
                                                    emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                                    emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                                    emailSubject: contructEmailSubjectPrefix(supportSheetData) + "AGENT DETAILS AT DISPORT",
                                                    emailContent: SupportSheetEmailContentConstant["Agent details at disport Owners"],
                                                    receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                                } as EmailEditorModel, supportSheetData.brokerEmails);
                                            } else {
                                                Utility.Alert.Error("Please select owner principle before sending email");
                                            }
                                        } else {
                                            if (supportSheetData.chartererBrokerContactPrinciple) {
                                                PopupEmail({
                                                    emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                                    emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                                    emailSubject: contructEmailSubjectPrefix(supportSheetData) + "AGENT DETAILS AT DISPORT",
                                                    emailContent: SupportSheetEmailContentConstant["Agent details at disport Chtrs"],
                                                    receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                                } as EmailEditorModel, supportSheetData.brokerEmails);
                                            } else {
                                                Utility.Alert.Error("Please select owner principle before sending email");
                                            }
                                        }
                                    }}
                                ></SupportSheetCustomCheckbox>
                            </Grid>
                            <Grid item xs={8}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Autocomplete
                                            disableClearable={true}
                                            options={["Owner", "Chtrs"]}
                                            disabled={isDontFollowShipment()}
                                            renderInput={(params) =>
                                                <TextField {...params} label="Agent Type"
                                                    error={
                                                        hasError(supportSheetData.enableValidation, supportSheetData.model.disportAgentType, isDontFollowShipment())
                                                    } />
                                            }
                                            value={supportSheetData.model.disportAgentType}
                                            onChange={(event: React.SyntheticEvent, value: string, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                                dispatch(setDisportAgentType(value));
                                            }}
                                            className={'support-sheet-send-draft-dropdown' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.disportAgentType, isDontFollowShipment())}
                                        />

                                    </Grid>
                                    <Grid item xs={4}>
                                        <PortSelector
                                            onPortChange={(value: PortModel | null) => {
                                                if (value) {
                                                    dispatch(setDisport((value as PortModel).id));
                                                } else {
                                                    dispatch(setDisport(null));
                                                }
                                            }}
                                            disable={isDontFollowShipment()}
                                            portLabel='Port Name'
                                            isAreaDisabled={true}
                                            hideArea={true}
                                            portValue={getPortById(supportSheetData.model.disport)}
                                            isAreaRelatedToPort={true}
                                            hasPortError={hasErrorNumber(supportSheetData.enableValidation, supportSheetData.model.disport, isDontFollowShipment())}
                                            className={'cargo-input-component' + getErrorNumberClass(supportSheetData.enableValidation, supportSheetData.model.disport, isDontFollowShipment())}
                                        >
                                        </PortSelector>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <AgentSelector
                                            label='Company Name'
                                            disabled={isDontFollowShipment()}
                                            selectedAgentId={supportSheetData.model.disportAgent}
                                            onChange={(value: AgentModel | null) => {
                                                dispatch(setDisportAgent(value ? value.id : null));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.disportAgent, isDontFollowShipment())
                                            }
                                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.disportAgent, isDontFollowShipment())}
                                        >
                                        </AgentSelector>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                }

                {(supportSheetData.currentFixture.bizType == MarketInfoType.TCT || supportSheetData.currentFixture.bizType == MarketInfoType.TC) &&
                    <>
                        <Grid container>
                            <Grid item xs={4}>
                                <SupportSheetCustomCheckbox
                                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Onhire bunker survey']) > -1 : false}
                                    onChange={(checked: boolean) => {
                                        updateCheckList(SupportSheetCheckListConstant['Onhire bunker survey'], checked);
                                    }}
                                    disable={isDontFollowShipment()}
                                    currentCheckedValue={SupportSheetCheckListConstant['Onhire bunker survey']}
                                    helpText={SupportSheetHelpTextConstant['Onhire bunker survey']}
                                    checkboxText={'Onhire bunker survey'}
                                    showSendEmail={true}
                                    onEmailClick={() => {
                                        if (supportSheetData.chartererBrokerContactPrinciple) {
                                            PopupEmail({
                                                emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                                emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                                emailSubject: contructEmailSubjectPrefix(supportSheetData) + "ON HIRE BUNKER SURVEY",
                                                emailContent: SupportSheetEmailContentConstant["Onhire bunker survey"],
                                                receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                            } as EmailEditorModel, supportSheetData.brokerEmails);
                                        } else {
                                            Utility.Alert.Error("Please select owner principle before sending email");
                                        }
                                    }}
                                ></SupportSheetCustomCheckbox>
                            </Grid>
                            <Grid item xs={8}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <PortSelector
                                            onPortChange={(value: PortModel | null) => {
                                                if (value) {
                                                    dispatch(setOnhireBunkerPort((value as PortModel).id));
                                                } else {
                                                    dispatch(setOnhireBunkerPort(null));
                                                }
                                            }}
                                            disable={isDontFollowShipment()}
                                            className={'cargo-input-component' + getErrorNumberClass(supportSheetData.enableValidation, supportSheetData.model.onhireBunkerPort, isDontFollowShipment())}
                                            portLabel='Port'
                                            isAreaDisabled={true}
                                            hideArea={true}
                                            portValue={getPortById(supportSheetData.model.onhireBunkerPort)}
                                            isAreaRelatedToPort={true}
                                            hasPortError={
                                                hasErrorNumber(supportSheetData.enableValidation, supportSheetData.model.onhireBunkerPort, isDontFollowShipment())
                                            }
                                        >
                                        </PortSelector>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <SurveyorSelector
                                            label='Surveyor company'
                                            disable={isDontFollowShipment()}
                                            selectedSurveyorId={supportSheetData.model.onhireBunkerSurveyorCompany}
                                            onChange={(value: SurveyorModel | null) => {
                                                dispatch(setOnhireBunkerSurveyorCompany(value ? value.id : null));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.onhireBunkerSurveyorCompany, isDontFollowShipment())
                                            }
                                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.onhireBunkerSurveyorCompany, isDontFollowShipment())}
                                        >
                                        </SurveyorSelector>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Surveyor details and cost"
                                            disabled={isDontFollowShipment()}
                                            fullWidth
                                            value={supportSheetData.model.onhireBunkerSurveyorDetailAndCost ? supportSheetData.model.onhireBunkerSurveyorDetailAndCost : ""}
                                            onChange={(event) => {
                                                dispatch(setOnhireBunkerSurveyorDetailAndCost(event.target.value));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.onhireBunkerSurveyorDetailAndCost, isDontFollowShipment())
                                            }
                                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.onhireBunkerSurveyorDetailAndCost, isDontFollowShipment())}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <SupportSheetCustomCheckbox
                                    checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Offhire bunker survey']) > -1 : false}
                                    onChange={(checked: boolean) => {
                                        updateCheckList(SupportSheetCheckListConstant['Offhire bunker survey'], checked);
                                    }}
                                    disable={isDontFollowShipment()}
                                    currentCheckedValue={SupportSheetCheckListConstant['Offhire bunker survey']}
                                    helpText={SupportSheetHelpTextConstant['Offhire bunker survey']}
                                    checkboxText={'Offhire bunker survey'}
                                    showSendEmail={true}
                                    onEmailClick={() => {
                                        if (supportSheetData.chartererBrokerContactPrinciple) {
                                            PopupEmail({
                                                emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                                emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                                emailSubject: contructEmailSubjectPrefix(supportSheetData) + "OFF HIRE BUNKER SURVEY",
                                                emailContent: SupportSheetEmailContentConstant["Offhire bunker survey"],
                                                receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic
                                            } as EmailEditorModel, supportSheetData.brokerEmails);
                                        } else {
                                            Utility.Alert.Error("Please select owner principle before sending email");
                                        }
                                    }}
                                ></SupportSheetCustomCheckbox>
                            </Grid>
                            <Grid item xs={8}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <PortSelector
                                            onPortChange={(value: PortModel | null) => {
                                                if (value) {
                                                    dispatch(setOffhireBunkerPort((value as PortModel).id));
                                                } else {
                                                    dispatch(setOffhireBunkerPort(null));
                                                }
                                            }}
                                            disable={isDontFollowShipment()}
                                            className={'cargo-input-component' + getErrorNumberClass(supportSheetData.enableValidation, supportSheetData.model.offhireBunkerPort, isDontFollowShipment())}
                                            portLabel='Port'
                                            isAreaDisabled={true}
                                            hideArea={true}
                                            portValue={getPortById(supportSheetData.model.offhireBunkerPort)}
                                            isAreaRelatedToPort={true}
                                            hasPortError={
                                                hasErrorNumber(supportSheetData.enableValidation, supportSheetData.model.offhireBunkerPort, isDontFollowShipment())
                                            }
                                        >
                                        </PortSelector>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <SurveyorSelector
                                            label='Surveyor company'
                                            disable={isDontFollowShipment()}
                                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.offhireBunkerSurveyorCompany, isDontFollowShipment())}
                                            selectedSurveyorId={supportSheetData.model.offhireBunkerSurveyorCompany}
                                            useFocusMode={true}
                                            onChange={(value: SurveyorModel | null) => {
                                                dispatch(setOffhireBunkerSurveyorCompany(value ? value.id : null));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.offhireBunkerSurveyorCompany, isDontFollowShipment())
                                            }
                                        >
                                        </SurveyorSelector>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            label="Surveyor details and cost"
                                            disabled={isDontFollowShipment()}
                                            fullWidth
                                            value={supportSheetData.model.offhireBunkerSurveyorDetailAndCost ? supportSheetData.model.offhireBunkerSurveyorDetailAndCost : ""}
                                            onChange={(event) => {
                                                dispatch(setOffhireBunkerSurveyorDetailAndCost(event.target.value));
                                            }}
                                            error={
                                                hasError(supportSheetData.enableValidation, supportSheetData.model.offhireBunkerSurveyorDetailAndCost, isDontFollowShipment())
                                            }
                                            className={'cargo-input-component' + getErrorClass(supportSheetData.enableValidation, supportSheetData.model.offhireBunkerSurveyorDetailAndCost, isDontFollowShipment())}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                }

                <Grid container>
                    <Grid item xs={1}>
                        <SupportSheetCustomCheckbox
                            checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Send draft FN to owner']) > -1 : false}
                            onChange={(checked: boolean) => {
                                updateCheckList(SupportSheetCheckListConstant['Send draft FN to owner'], checked);
                            }}
                            disable={isDontFollowShipment()}
                            currentCheckedValue={SupportSheetCheckListConstant['Send draft FN to owner']}
                            helpText={SupportSheetHelpTextConstant['Send draft FN to owner']}
                            checkboxText={''}
                            showSendEmail={true}
                            className="support-sheet-send-draft"
                            helpTextTitle="Send draft FN/Working CP to Owners"
                            onEmailClick={() => {
                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                    PopupEmail({
                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + "FN",
                                        emailContent: supportSheetData.model.isSendDraftToFN ? SupportSheetEmailContentConstant["Send draft FN to owner"] : SupportSheetEmailContentConstant["Send draft working CP to owner"],
                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                } else {
                                    Utility.Alert.Error("Please select owner principle before sending email");
                                }
                            }}
                        ></SupportSheetCustomCheckbox>
                    </Grid>
                    <Grid item xs={11}>
                        <Autocomplete
                            className='support-sheet-send-draft-dropdown'
                            disabled={isDontFollowShipment()}
                            disableClearable={true}
                            options={["Send draft FN to owners", "Send draft Working CP to Owners"]}
                            renderInput={(params) => <TextField {...params} label="" />}
                            value={supportSheetData.model.isSendDraftToFN ? "Send draft FN to owners" : "Send draft Working CP to Owners"}
                            onChange={(event: React.SyntheticEvent, value: string, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                dispatch(setIsSendDraftToFN(value == "Send draft FN to owners"));
                            }}
                        />
                    </Grid>
                </Grid>
                <div>
                    <Switch
                        className='support-sheet-switch'
                        disabled={isDontFollowShipment()}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                            updateCheckList(SupportSheetCheckListConstant['Both sides signed FN'], checked);
                        }}
                        checked={supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Both sides signed FN']) > -1 : false} />
                    <SupportSheetHelpText
                        title=""
                        helpText={SupportSheetHelpTextConstant['Both sides signed FN']}
                    >
                    </SupportSheetHelpText>
                    <span
                        onClick={() => {
                            if (supportSheetData.model.checkLists ? supportSheetData.model.checkLists.indexOf(SupportSheetCheckListConstant['Both sides signed FN']) > -1 : false) {
                                updateCheckList(SupportSheetCheckListConstant['Both sides signed FN'], true);
                            } else {
                                updateCheckList(SupportSheetCheckListConstant['Both sides signed FN'], false);
                            }
                        }}
                        className={'checkbox-text ' + (isDontFollowShipment() ? "email-disable" : "")}
                    >
                        {(supportSheetData.currentFixture.bizType == MarketInfoType.Voy || supportSheetData.currentFixture.bizType == MarketInfoType.COA) ? 'Both sides signed FN?' : 'Both sides signed FN/CP?'}
                    </span>
                </div>
            </CustomAccordion >
        </>
    )
};

export default SupportSheetPreVoyage;